<template>
  <form class="px-5 py-6 xl:p-10 bg-white rounded-2xl shadow-sm">
    <div class="flex items-center justify-between mb-10">
      <h3 class="text-xl xl:text-3xl font-bold text-bg-bg-black-blue">
        Mi Perfil
      </h3>
      <div class="flex items-center gap-3">
        <button
          @click.prevent="$emit('cambio', 'deleteCount')"
          class="py-4 px-6 bg-mainRed text-white font-semibold rounded-xl text-sm flex items-center gap-3"
          type="button"
        >
          <img src="../../assets/icons/eliminar.png" alt="Editar..." />
          <span class="hidden xl:block">Eliminar cuenta</span>
        </button>
      </div>
    </div>

    <h3 class="font-bold text-text-blue text-sm xl:text-lg mb-8">
      Información del cliente
    </h3>

    <div class="grid xl:grid-cols-2 gap-8 mb-12">
      <div class="grid gap-8 order-2 xl:order-1">
        <!-- Nombres -->
        <div>
          <label
            for="nombres"
            class="block mb-2 font-semibold text-xs xl:text-sm"
            >Nombres:</label
          >
          <input
            id="nombres"
            class="p-6 input w-full text-sm xl:text-base bg-gray-100 bg-opacity-50 focus:border-blue-400 shadow-sm rounded-2xl"
            type="text"
            placeholder="Nombres"
            v-model="data.name"
          />
          <span
            class="text-mainRed text-xs pt-1 pl-7 font-medium"
            v-if="error.name"
            >*Ingrese su nombre</span
          >
        </div>
        <!-- Apellidos -->
        <div>
          <label
            for="apellidos"
            class="block mb-2 font-semibold text-xs xl:text-sm"
            >Apellidos:</label
          >
          <input
            id="apellidos"
            class="p-6 input w-full text-sm xl:text-base bg-gray-100 bg-opacity-50 focus:border-blue-400 shadow-sm rounded-2xl"
            type="text"
            placeholder="Apellidos"
            v-model="data.apellido"
          />
          <span
            class="text-mainRed text-xs pt-1 pl-7 font-medium"
            v-if="error.apellido"
            >*Ingrese su apellido</span
          >
        </div>
      </div>
      <div class="order-1 xl:order-2">
        <!-- Foto de perfil -->

        <div class="relative xl:w-max">
          <label class="block mb-2 font-semibold text-xs xl:text-sm"
            >Foto de perfil:</label
          >
          <img
            :src="imgData"
            alt=""
            class="object-contain w-full xl:w-60 xl:h-60 rounded-full border shadow-xl"
          />
          <label class="cursor-pointer" for="foto_perfil">
            <img
              class="absolute bottom-0 -right-4 cursor-pointer"
              src="../../assets/icons/camara-circle.svg"
              alt="Icono de Envios USA"
            />
            <input
              type="file"
              @change="previewImage"
              accept="image/png,image/jpeg,image/jpg"
              id="foto_perfil"
              class="hidden"
            />
          </label>
        </div>
      </div>
    </div>
    <h3 class="font-bold text-text-blue text-sm xl:text-lg mb-8">
      Dirección de facturación
    </h3>
    <div class="grid xl:grid-cols-2 gap-8 mb-8">
      <!-- Direccion -->
      <div v-if="data.state">
        <label
          for="direccion"
          class="block mb-2 font-semibold text-xs xl:text-sm"
          >Dirección:</label
        >
        <input
          id="direccion"
          class="p-6 input w-full text-sm xl:text-base bg-gray-100 bg-opacity-50 focus:border-blue-400 shadow-sm rounded-2xl"
          type="text"
          v-model="data.direccion"
          @keypress="stateGmapAUtocomplete"
          placeholder="Ingrese una dirección"
        />
        <span
          class="text-mainRed text-xs pt-1 pl-7 font-medium"
          v-if="error.direction || error.lat || error.lng"
          >*Ingrese y seleccione su dirección</span
        >
      </div>

      <div v-else>
        <label
          for="direccion"
          class="block mb-2 font-semibold text-xs xl:text-sm"
          >Dirección:</label
        >
        <GMapAutocomplete
          placeholder="Ingrese una dirección"
          @place_changed="setPlace"
          class="p-6 input w-full text-sm xl:text-base bg-gray-100 bg-opacity-50 focus:border-blue-400 shadow-sm rounded-2xl"
        >
        </GMapAutocomplete>
        <span
          class="text-mainRed text-xs pt-1 pl-7 font-medium"
          v-if="error.direction || error.lat || error.lng"
          >*Ingrese y seleccione su dirección</span
        >
      </div>

      <!-- Departamento -->

      <div>
        <label
          for="documento"
          class="block mb-2 font-semibold text-xs xl:text-sm"
          >Departamento:</label
        >
        <input
          id="documento"
          class="p-6 input w-full text-sm xl:text-base bg-gray-100 bg-opacity-50 focus:border-blue-400 shadow-sm rounded-2xl"
          type="text"
          placeholder="Ingrese el departamento"
          v-model="data.departamento"
        />
        <span
          class="text-mainRed text-xs pt-1 pl-7 font-medium"
          v-if="error.departamento"
          >*Ingrese el departamento</span
        >
      </div>

      <!-- N° Piso/Oficina -->
      <div>
        <label for="piso" class="block mb-2 font-semibold text-xs xl:text-sm"
          >N° Piso/Oficina</label
        >
        <input
          id="piso"
          class="p-6 input w-full text-sm xl:text-base bg-gray-100 bg-opacity-50 focus:border-blue-400 shadow-sm rounded-2xl"
          type="text"
          placeholder="Ingrese el piso u oficina"
          v-model="data.piso"
        />
        <span
          class="text-mainRed text-xs pt-1 pl-7 font-medium"
          v-if="error.piso"
          >*Ingrese el piso u oficina</span
        >
      </div>
      <!-- Provincia -->
      <div>
        <label
          for="documento"
          class="block mb-2 font-semibold text-xs xl:text-sm"
          >Provincia:</label
        >
        <input
          id="documento"
          class="p-6 input w-full text-sm xl:text-base bg-gray-100 bg-opacity-50 focus:border-blue-400 shadow-sm rounded-2xl"
          type="text"
          placeholder="Ingrese la provincia"
          v-model="data.provincia"
        />
        <span
          class="text-mainRed text-xs pt-1 pl-7 font-medium"
          v-if="error.provincia"
          >*Ingrese la provincia</span
        >
      </div>
      <!-- N° Piso/Oficina -->
      <div>
        <label
          for="referencia"
          class="block mb-2 font-semibold text-xs xl:text-sm"
          >Referencia:</label
        >
        <input
          id="referencia"
          class="p-6 input w-full text-sm xl:text-base bg-gray-100 bg-opacity-50 focus:border-blue-400 shadow-sm rounded-2xl"
          type="text"
          placeholder="Ingrese la referencia"
          v-model="data.referencia"
        />
        <span
          class="text-mainRed text-xs pt-1 pl-7 font-medium"
          v-if="error.referencia"
          >*Ingrese la referencia</span
        >
      </div>
      <!-- Distrito -->
      <div>
        <label
          for="documento"
          class="block mb-2 font-semibold text-xs xl:text-sm"
          >Distrito:</label
        >
        <input
          id="documento"
          class="p-6 input w-full text-sm xl:text-base bg-gray-100 bg-opacity-50 focus:border-blue-400 shadow-sm rounded-2xl"
          type="text"
          placeholder="Ingrese el distrito"
          v-model="data.distrito"
        />
        <span
          class="text-mainRed text-xs pt-1 pl-7 font-medium"
          v-if="error.distrito"
          >*Ingrese el distrito</span
        >
      </div>
    </div>
    <button
      class="py-4 px-6 bg-mainGreenLight text-white font-semibold rounded-xl text-sm flex items-center gap-3"
      @click.prevent="updateUser"
      type="submit"
    >
      <img src="../../assets/icons/editar.png" alt="Editar..." />
      <span class="block">Guardar cambios</span>
    </button>
  </form>
</template>
<script>
import imgDefault from "../../assets/images/foto-perfil.png";
import { server } from "../../config/global";
const BASE_URL = server.API_URL;

import axios from "axios";
export default {
  props: ["id", "identificador"],
  data() {
    return {
      data: {
        idAdress: "",
        state: false,
        name: "",
        apellido: "",
        documento: "",
        telefono: "",
        emailContact: "",
        direccion: "",
        piso: "",
        referencia: "",
        departamento: "",
        provincia: "",
        distrito: "",
        lat: 0,
        lng: 0,
      },
      error: {
        name: false,
        apellido: false,
        piso: false,
        referencia: false,
        departamento: false,
        provincia: false,
        distrito: false,
        documento: false,
        telefono: false,
        correo: false,
        direction: false,
        lat: false,
        lng: false,
      },
      imgData: "",
      imagePreview: "",
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    previewImage(e) {
      const file = e.target.files[0];
      this.cargarImagen(file);
    },
    cargarImagen(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
        this.imgData = e.target.result;
        this.updateImage();
      };
      reader.readAsDataURL(file);
    },
    updateImage() {
      axios
        .put(`${BASE_URL}` + "client/update-client-image/" + this.id, {
          profile_image: this.imagePreview,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$store.state.alert.titulo = "Éxito";
            this.$store.state.alert.description =
              "Foto de perfil actualizado con éxito";
            this.$store.state.alert.estado = true;
            const dataId = response.data.body.id;
            const dataName =
              response.data.body.attributes.profile.attributes.name;
            const dataLastName =
              response.data.body.attributes.profile.attributes.surnames;
            const dataImage =
              response.data.body.attributes.profile.attributes.userable
                .attributes.profile_image_url;
            const dni = response.data.body.attributes.validation.verified;
            const dataLocal = JSON.parse(localStorage.getItem("auth"));
            const email = dataLocal.glovalEmail;
            const dataIdentificador = dataLocal.identificador;
            const type = dataLocal.type;
            const dataUser = {
              globalID: dataId,
              globalName: dataName,
              globalLastName: dataLastName,
              globalImage: dataImage,
              globalValidate: dni,
              glovalEmail: email,
              identificador: dataIdentificador,
              type: type,
            };
            const dataCompress = JSON.stringify(dataUser);
            localStorage.setItem("auth", dataCompress);
            location.reload();
          }
        })
        .catch((error) => {
          if (error) {
            //----------component--------//
            this.$store.state.alert.titulo = "Error";
            this.$store.state.alert.description =
              "Error al intentar cambiar la foto de Perfil";
            this.$store.state.alert.estado = true;
            //--------------------------//
          }
        });
    },

    //validar que todos los campos esten rellenado para actualizar
    formValidate() {
      this.error.name = this.data.name.length !== 0 ? false : true;
      this.error.apellido = this.data.apellido.length !== 0 ? false : true;
      this.error.piso = this.data.piso.length !== 0 ? false : true;
      this.error.referencia = this.data.referencia.length !== 0 ? false : true;
      this.error.departamento =
        this.data.departamento.length !== 0 ? false : true;
      this.error.provincia = this.data.provincia.length !== 0 ? false : true;
      this.error.distrito = this.data.distrito.length !== 0 ? false : true;
      // this.error.documento = this.data.documento.toString().length !== 0 ? false : true;
      // this.error.telefono = this.data.telefono.toString().length !== 0 ? false : true;
      // this.error.correo = this.data.emailContact.length !== 0 ? false : true;
      this.error.direction = this.data.direccion.length !== 0 ? false : true;
      this.error.lat = this.data.lat !== 0 ? false : true;
      this.error.lng = this.data.lng !== 0 ? false : true;

      if (
        this.error.name ||
        this.error.apellido ||
        this.error.piso ||
        this.error.referencia ||
        this.error.departamento ||
        this.error.provincia ||
        this.error.distrito ||
        // this.error.documento ||
        // this.error.telefono ||
        // this.error.correo ||
        this.error.direction ||
        this.error.lat ||
        this.error.lng
      ) {
        return false;
      } else {
        return true;
      }

      // if (
      //   name.length !== 0 &&
      //   apellido.length !== 0 &&
      //   piso.length !== 0 &&
      //   referencia.length !== 0 &&
      //   departamento.length !== 0 &&
      //   provincia.length !== 0 &&
      //   distrito.length !== 0 &&
      //   documento.length !== 0 &&
      //   telefono.length !== 0 &&
      //   correo.length !== 0 &&
      //   direction.length !== 0 &&
      //   lat !== 0 &&
      //   lng !== 0
      // ) {
      //   return true;
      // } else {
      //   alert("Ingresar todos los campos");
      //   return false;
      // }
    },
    //metodo para actualizar al usuario
    updateUser() {
      const result = this.formValidate();
      if (result) {
        axios
          .post(`${BASE_URL}` + "client/update-client-sendi/" + this.id, {
            name: this.data.name,
            surnames: this.data.apellido,
            // cellphone: this.data.telefono,
            // document_number: this.data.documento,
            // email: this.data.emailContact,
            address: this.data.direccion,
            inner: this.data.piso,
            reference: this.data.referencia,
            department: this.data.departamento,
            city: this.data.provincia,
            district: this.data.distrito,
            address_id: this.data.idAdress,
            latitud: this.data.lat,
            longitud: this.data.lng,
          })
          .then((response) => {
            if (response.status === 200) {
              const data = response.data.body;
              const name = data.attributes.profile.attributes.name;
              const apellido = data.attributes.profile.attributes.surnames;
              const dataIdentificador = data.client_code;
              const dataLocal = JSON.parse(localStorage.getItem("auth"));
              const id = dataLocal.globalID;
              const img = dataLocal.globalImage;
              const dni = dataLocal.globalValidate;
              const email = dataLocal.glovalEmail;
              const type = dataLocal.type;
              const dataUser = {
                globalID: id,
                globalName: name,
                globalLastName: apellido,
                globalImage: img,
                globalValidate: dni,
                glovalEmail: email,
                identificador: dataIdentificador,
                type: type,
              };
              const dataCompress = JSON.stringify(dataUser);
              localStorage.setItem("auth", dataCompress);
              if (response.data.body.attributes.addresses.length !== 0) {
                const data = {};
                data.nombre =
                  response.data.body.attributes.addresses[0].attributes.address;
                data.lat =
                  response.data.body.attributes.addresses[0].attributes.lat;
                data.lng =
                  response.data.body.attributes.addresses[0].attributes.lng;
                data.departamento =
                  response.data.body.attributes.addresses[0].attributes.department;
                data.provincia =
                  response.data.body.attributes.addresses[0].attributes.city;
                data.distrito =
                  response.data.body.attributes.addresses[0].attributes.district;
                data.location =
                  response.data.body.attributes.addresses[0].attributes.free;
                const dataCompress = JSON.stringify(data);
                window.localStorage.setItem("direction", dataCompress);
              }
              location.reload();
            }
          })
          .catch((error) => {
            if (error) {
              //----------component--------//
              this.$store.state.alert.titulo = "Error";
              this.$store.state.alert.description =
                "Error al actualizar los datos";
              this.$store.state.alert.estado = true;
              //--------------------------//
            }
          });
      }
    },
    //cambia el estado dle input para que se muestre el otro componente
    stateGmapAUtocomplete() {
      this.data.state = false;
      this.data.direccion = "";
    },
    //solo numeros
    onlyNumber($event) {
      if (
        $event.key === "-" ||
        $event.key === "," ||
        $event.key === "." ||
        $event.key === "+"
      ) {
        $event.preventDefault();
      }
    },
    setPlace(place) {
      this.data.direccion = place.name;
      this.data.lat = place.geometry.location.lat();
      this.data.lng = place.geometry.location.lng();
      //Obtener distrito-departamento-provincia
      var addressComponents = place.address_components;
      var departamento = "";
      var provincia = "";
      var distrito = "";
      var country = "";

      addressComponents.forEach((value) => {
        if (value.types[0] === "administrative_area_level_1") {
          departamento = value.long_name;
        }
        if (value.types[0] === "administrative_area_level_2") {
          provincia = value.long_name;
        }
        if (value.types[0] === "locality") {
          distrito = value.long_name;
        }
        if (value.types[0] === "country") {
          country = value.short_name;
        }
      });
      if (country !== "PE" || country === "") {
        this.data.direction = "";
        this.data.lat = 0;
        this.data.lng = 0;
        //----------component--------//
        this.$store.state.alert.titulo = "Validación";
        this.$store.state.alert.description = "Solo direcciones de Perú";
        this.$store.state.alert.estado = true;
        //--------------------------//
      }
      this.data.departamento = departamento;
      this.data.provincia = provincia;
      this.data.distrito = distrito;
    },
    //Obteniendo datos del usuario
    getUser() {
      axios
        .get(`${BASE_URL}` + "client/getById/" + this.id)
        .then((response) => {
          if (response.status === 200) {
            var dataUser = response.data.body.data;
            //Obtenemos la imagen
            if (
              dataUser.attributes.profile.attributes.userable.attributes
                .profile_image_url === null
            ) {
              this.imgData = imgDefault;
            } else {
              this.imgData =
                dataUser.attributes.profile.attributes.userable.attributes.profile_image_url;
            }
            //Nombre
            this.data.name =
              dataUser.attributes.profile.attributes.name === null
                ? ""
                : dataUser.attributes.profile.attributes.name;
            //apellido
            this.data.apellido =
              dataUser.attributes.profile.attributes.surnames === null
                ? ""
                : dataUser.attributes.profile.attributes.surnames;
            //Documento
            this.data.documento =
              dataUser.attributes.profile.attributes.document_number === null
                ? ""
                : dataUser.attributes.profile.attributes.document_number;
            //telefono
            this.data.telefono =
              dataUser.attributes.profile.attributes.cellphone === null
                ? ""
                : dataUser.attributes.profile.attributes.cellphone;
            // correo de contacto
            this.data.emailContact =
              dataUser.attributes.profile.attributes.userable.attributes
                .biography === null
                ? dataUser.attributes.profile.attributes.userable.attributes
                    .email
                : dataUser.attributes.profile.attributes.userable.attributes
                    .biography;

            //Datos de la dirección y valida si el campo de addres es cero se les coloca string vacio
            if (dataUser.attributes.addresses.length !== 0) {
              this.data.state = true;
              //direccion
              this.data.direccion =
                dataUser.attributes.addresses[0].attributes.address === null
                  ? ""
                  : dataUser.attributes.addresses[0].attributes.address;
              //piso
              this.data.piso =
                dataUser.attributes.addresses[0].attributes.inner === null
                  ? ""
                  : dataUser.attributes.addresses[0].attributes.inner;
              //referencia
              this.data.referencia =
                dataUser.attributes.addresses[0].attributes.reference === null
                  ? ""
                  : dataUser.attributes.addresses[0].attributes.reference;
              //departamento
              this.data.departamento =
                dataUser.attributes.addresses[0].attributes.department === null
                  ? ""
                  : dataUser.attributes.addresses[0].attributes.department;
              //provincia
              this.data.provincia =
                dataUser.attributes.addresses[0].attributes.city === null
                  ? ""
                  : dataUser.attributes.addresses[0].attributes.city;
              //distrito
              this.data.distrito =
                dataUser.attributes.addresses[0].attributes.district === null
                  ? ""
                  : dataUser.attributes.addresses[0].attributes.district;
              //latitud
              this.data.lat =
                dataUser.attributes.addresses[0].attributes.lat === null
                  ? 0
                  : dataUser.attributes.addresses[0].attributes.lat;
              //longitud
              this.data.lng =
                dataUser.attributes.addresses[0].attributes.lng === null
                  ? 0
                  : dataUser.attributes.addresses[0].attributes.lng;
              this.data.idAdress = dataUser.attributes.addresses[0].id;
            } else {
              this.data.direccion = "";
              this.data.piso = "";
              this.data.referencia = "";
              this.data.departamento = "";
              this.data.provincia = "";
              this.data.distrito = "";
              this.data.lat = 0;
              this.data.lng = 0;
              this.data.state = false;
            }
          }
        })
        .catch((error) => {
          if (error) {
            //----------component--------//
            this.$store.state.alert.titulo = "Error";
            this.$store.state.alert.description = "Error al mostrar sus datos";
            this.$store.state.alert.estado = true;
            //--------------------------//
          }
        });
    },
  },
};
</script>
